import type VueRouter from 'vue-router';
import { computed } from 'vue';
import { useVm } from './useVm';

type Route = import('vue-router').Route;

export function useRouter(): VueRouter {
  return useVm().$router;
}

export function useRoute(): Route {
  return useVm().$route;
}

export function useRouteRef() {
  const vm = useVm();
  return computed(() => vm.$route);
}
